<template>
    <a class="col-md-6 col-md-6 col-sm-12 mt-md-0 mt-4" style="display: block;">
        <div class="card-wrapper">
            <div class="card" style="justify-content: center; align-items: center;"
                :style="{ backgroundColor: contractData && contractData.cor_primaria ? contractData.cor_primaria : '#bfbebb' }">
                <img :src="contractData && contractData.logo_path ? contractData.logo_path : null" alt=""
                    style="max-width: 100%; max-height: 100%; display: block; margin: auto;">
            </div>
        </div>
    </a>
</template>

<script setup>
import { useStore } from "vuex";
import { computed } from "vue";

const store = useStore();

const contractData = computed(() => store.getters.getCurrentContract);
</script>

<style scoped>
.card-wrapper {
    width: 100%;
    height: 190px;
}

.card {
    width: 100%;
    height: 100%;
}
</style>
